/* eslint-disable no-unused-vars */
import { ParagraphWithTooltip, MenuItem } from 'components';
import { Palette } from 'config';
import ReactCountryFlag from 'react-country-flag';
import { cleanSelectedTableItems } from 'utils';

export const HeadSearchItem = ({ isAllItemsSelected, getObjForAllBtn, toggleAllOff, rerender }) => {
  return (
    <MenuItem
      isSelected={isAllItemsSelected}
      height={40}
      value={getObjForAllBtn.value}
      key={getObjForAllBtn.value}
      onClick={() => {
        toggleAllOff();
        rerender();
        cleanSelectedTableItems();
      }}
      wrapStyle={{ width: '280px' }}
      style={{ marginBottom: '2px' }}
    >
      <ParagraphWithTooltip
        text={getObjForAllBtn.text}
        style={{ fontSize: '14px', fontWeight: '400' }}
      />
    </MenuItem>
  );
};

export const CountrySearchItem = ({ isActive, item, index, toggle, rerender, searchValue$ }) => {
  const my_country_code = item?.CountryCode === 'UK' ? 'GB' : item?.CountryCode;

  return (
    <MenuItem
      isSelected={isActive(item?.CountryCode)}
      height={40}
      value={item?.CountryCode}
      key={index}
      onClick={() => {
        toggle(item?.CountryCode);
        rerender();
        cleanSelectedTableItems();
      }}
      wrapStyle={{ width: '280px', display: 'flex', alignItems: 'center' }}
      style={{ marginBottom: '2px' }}
    >
      <ReactCountryFlag
        countryCode={my_country_code}
        svg
        style={{
          width: '20px',
          height: '15px',
          marginRight: '8px',
        }}
      />
      <div style={{ width: '95%' }}>
        <ParagraphWithTooltip
          text={` ${item?.Country} - ${item?.CountryCode}`}
          search={searchValue$.value}
          isHighlight
          highlightStyle={{ color: `${Palette.Primary._500}`, fontWeight: '500' }}
        />
      </div>
    </MenuItem>
  );
};

export const AppSearchItem = ({ isActive, item, index, toggle, rerender, searchValue$ }) => {
  return (
    <MenuItem
      isSelected={isActive(item?.pba_id)}
      height={40}
      value={item?.pba_number}
      key={index}
      onClick={() => {
        toggle(item?.pba_id);
        rerender();
        cleanSelectedTableItems();
      }}
      wrapStyle={{ width: '280px' }}
      style={{ marginBottom: '2px' }}
    >
      <ParagraphWithTooltip
        text={`${item?.Apps}`}
        style={{ fontSize: '14px', fontWeight: '400' }}
        search={searchValue$.value}
        isHighlight
        highlightStyle={{ color: `${Palette.Primary._900}`, fontWeight: '700' }}
      />
      <ParagraphWithTooltip
        text={`ID:${item?.pba_number?.toString()}`}
        style={{
          fontSize: '12px',
          fontWeight: '400',
          color: Palette.PrimaryGray._700,
        }}
        search={searchValue$.value}
        isHighlight
        highlightStyle={{ color: `${Palette.Primary._900}`, fontWeight: '700' }}
      />
    </MenuItem>
  );
};
